import React from 'react';
import { Link } from 'react-router-dom';

export default function Privacy() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-primary, #0a0a0f)', color: 'var(--text-primary, #e4e4f0)', padding: '60px 24px' }}>
      <div style={{ maxWidth: 760, margin: '0 auto' }}>

        {/* Header */}
        <div style={{ marginBottom: 48 }}>
          <Link to="/login" style={{ fontFamily: 'monospace', fontSize: 11, color: 'var(--text-dim, #666)', textDecoration: 'none', letterSpacing: '2px' }}>
            ← BACK TO SIGNAL
          </Link>
          <div style={{ fontFamily: 'monospace', fontSize: 10, color: 'var(--text-dim, #666)', letterSpacing: '3px', textTransform: 'uppercase', marginTop: 32, marginBottom: 8 }}>
            Legal
          </div>
          <h1 style={{ fontSize: 32, fontWeight: 600, marginBottom: 8 }}>Privacy Policy</h1>
          <p style={{ color: 'var(--text-dim, #888)', fontSize: 13 }}>
            Effective Date: March 23, 2026 &nbsp;·&nbsp; GoLaunchNow Inc. &nbsp;·&nbsp; golaunchnow.io
          </p>
        </div>

        <style>{`
          .pp-section { margin-bottom: 40px; }
          .pp-section h2 { font-size: 18px; font-weight: 600; margin-bottom: 14px; color: #e4e4f0; }
          .pp-section p, .pp-section li { font-size: 14px; line-height: 1.8; color: #aaa; margin-bottom: 10px; }
          .pp-section ul { padding-left: 20px; }
          .pp-section li { margin-bottom: 6px; }
          a { color: #a78bfa; }
        `}</style>

        <div className="pp-section">
          <h2>1. Introduction</h2>
          <p>
            Welcome to Signal. We are committed to protecting your privacy. This Privacy Policy explains how we
            collect, use, process, and safeguard your information when you use our Integrated Social Intelligence
            Platform, which includes our Signal and PALM Voice of Customer (VOC) tools.
          </p>
        </div>

        <div className="pp-section">
          <h2>2. Information We Collect</h2>
          <p>To provide our social listening and intelligence services, we collect the following types of data:</p>
          <ul>
            <li>
              <strong style={{ color: '#e4e4f0' }}>Account &amp; Connection Data:</strong> When you connect your
              social media accounts to our platform, we collect and securely store OAuth access tokens and account IDs.
            </li>
            <li>
              <strong style={{ color: '#e4e4f0' }}>Post Performance Metrics (Signal):</strong> We collect post metrics
              from your connected accounts, including engagement rate, reach, and impressions.
            </li>
            <li>
              <strong style={{ color: '#e4e4f0' }}>Public Social Media Comments (PALM VOC):</strong> When a post
              reaches a "viral" threshold, our Comment Ingestion Service automatically fetches public comment datasets
              from connected platforms like Instagram, TikTok, and Facebook. This data includes the comment text,
              author names, like counts, reply counts, and posting timestamps.
            </li>
          </ul>
        </div>

        <div className="pp-section">
          <h2>3. How We Use Your Information</h2>
          <p>We use the collected data strictly to operate and improve our platform. Specifically, we use it to:</p>
          <ul>
            <li>Track content performance and identify successful content patterns.</li>
            <li>
              Process viral post comments through our VOC Analyser to identify audience questions, objections,
              misconceptions, and curiosity signals.
            </li>
            <li>Generate and email automated weekly market intelligence briefs to your team.</li>
          </ul>
        </div>

        <div className="pp-section">
          <h2>4. Third-Party Service Providers</h2>
          <p>To deliver our core functionality, we share specific data with trusted third-party providers:</p>
          <ul>
            <li>
              <strong style={{ color: '#e4e4f0' }}>AI Analysis (Anthropic/Claude):</strong> We send batches of public
              comment data to the Claude API to generate structured Voice of Customer intelligence briefs.
            </li>
            <li>
              <strong style={{ color: '#e4e4f0' }}>Social Media Platforms:</strong> Our service relies on existing API
              connections to platforms like Meta (Facebook/Instagram Graph API) and TikTok (TikTok Open API) to fetch data.
            </li>
            <li>
              <strong style={{ color: '#e4e4f0' }}>Hosting &amp; Infrastructure:</strong> Our backend services and
              MySQL databases are hosted on Hostinger.
            </li>
          </ul>
        </div>

        <div className="pp-section">
          <h2>5. Data Retention and Storage</h2>
          <p>
            We store your post insights, viral post logs, and structured AI analyses in our MySQL database. Raw post
            comments are capped at a maximum of 5,000 fetched comments per viral post to ensure data minimization and
            system efficiency.
          </p>
        </div>

        <div className="pp-section">
          <h2>6. Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy or how we handle your data, please contact us at:
            {' '}<a href="mailto:privacy@golaunchnow.io">privacy@golaunchnow.io</a>.
          </p>
        </div>

        <div style={{ marginTop: 60, paddingTop: 24, borderTop: '1px solid rgba(255,255,255,0.06)',
                      display: 'flex', gap: 24, fontSize: 12, color: 'var(--text-dim, #666)' }}>
          <Link to="/privacy" style={{ color: 'inherit' }}>Privacy Policy</Link>
          <Link to="/terms"   style={{ color: 'inherit' }}>Terms of Service</Link>
          <a href="mailto:privacy@golaunchnow.io" style={{ color: 'inherit' }}>Contact</a>
        </div>

      </div>
    </div>
  );
}
